import React from 'react';

const XIcon = () => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31.0436 3.17188H36.6661L24.3827 17.211L38.8332 36.3152H27.5186L18.6566 24.7286L8.51642 36.3152H2.89056L16.0289 21.2987L2.1665 3.17188H13.7684L21.7788 13.7624L31.0436 3.17188ZM29.0703 32.9498H32.1858L12.0755 6.36043H8.73227L29.0703 32.9498Z" fill="black" />
  </svg>
);

export default XIcon;